export const testimonials = [
  {
    quote:
      'The professional report identified $315K in annual savings. Report paid for itself in the first month.',
    author: 'Sarah Johnson, Energy Manager',
    company: 'Sunrise Food Processing',
    savings: '$315,000',
    detail: 'Food & Beverage Processing - 1 month payback'
  },
  {
    quote:
      'Beyond energy savings, we gained $185K annually from productivity improvements we never knew existed.',
    author: 'Mike Chen, Plant Manager',
    company: 'Valley Bakery & Manufacturing',
    savings: '$185,000',
    detail: 'Productivity gains beyond energy'
  },
  {
    quote:
      'The grant matching saved us $125K+ in implementation costs. Best $990 we ever spent.',
    author: 'Jennifer Williams, Facility Director',
    company: 'Metro Industrial Solutions',
    savings: '$125,000',
    detail: 'Grant funding secured'
  }
];


